export default __webpack_public_path__ + "static/media/AMS - download-not2.0a4320fc.svg";